import React from 'react';

import moment from 'moment';
import Loading from '../../common/Loading';
import _ from 'lodash';
import { Tooltip, Select, Button, Row, Col, DatePicker } from 'antd/lib';
import { Form } from '@ant-design/compatible';
import * as Icons from '@ant-design/icons';

// const FormItem = Form.Item;
import { graphql, compose } from 'react-apollo';

import getOrganismos from '../../../graphql/querys/organismos/getOrganismos.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import getEnvironment from '../../../graphql/querys/common/getEnvironment.graphql';

const { Item: FormItem } = Form;

@compose(
  graphql(getUsuario, {
    name: 'usuario',
  }),
  graphql(getOrganismos),
  graphql(getEnvironment, {
    name: 'getEnvironment',
  })
)
class FormRangoFechas extends React.Component {
  state = {
    llamada: false,
    fecha: '2023',
  };

  onSubmit = e => {
    e.preventDefault();
    // console.log(this.props);
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        if (this.state.fecha && this.state.idOrganismo) {
          this.props.buscar(
            values.fecha,
            values.idOrganismo,
            this.obtenerNombreOrganismo(values.idOrganismo)
          );
        }
      }
    });
  };

  onSubmitSQL = () => {
    console.log(this.props);
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        // console.log('Received values of form: ', values);
        if (this.state.fecha && this.state.idOrganismo) {
          this.props.buscarSQL(
            values.fecha,
            values.idOrganismo,
            this.obtenerNombreOrganismo(values.idOrganismo)
          );
        }
      }
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    // console.log('next: ', nextProps);
    if (nextProps.usuario && !this.state.llamada) {
      // console.log('VOY A RECIBIR PROPS: ', nextProps);
      this.cambiarOrganismo(nextProps.usuario.getUsuario.organismo._id);
    }
  }

  cambiarFecha = fecha => {
    this.setState({
      ...this.state,
      fecha: fecha,
    });
  };

  cambiarOrganismo = idOrganismo => {
    this.setState({
      ...this.state,
      idOrganismo: idOrganismo,
      nombreOrganismo: this.obtenerNombreOrganismo(idOrganismo),
    });
  };

  obtenerNombreOrganismo = idOrganismo => {
    let nombre = '';
    let organismo = _.find(this.props.data.getOrganismos, { _id: idOrganismo });
    organismo
      ? (nombre = organismo.nombre)
      : (nombre = this.props.usuario.getUsuario.organismo.nombre);
    return nombre;
  };

  render() {
    const { data } = this.props;
    if (data.loading) {
      return <Loading />;
    }

    const { getFieldDecorator } = this.props.form;
    let usuario = this.props.usuario.getUsuario;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 18,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 4,
        },
      },
    };

    return (
      <div>
        <hr />
        <br />
        <h3 className="tituloForm">Seleccion de Fecha</h3>
        <Form
          onSubmit={this.onSubmit}
          style={{ marginTop: 50, marginRight: 40 }}
        >
          <Row>
            <Col span={16} offset={4}>
              <FormItem
                {...formItemLayout}
                label={
                  <span>
                    Año del Reporte
                    <Tooltip title="Seleccione el año del reporte">
                      <Icons.QuestionCircleOutlined />
                    </Tooltip>
                  </span>
                }
                // valuePropName={'date'}
              >
                {getFieldDecorator('fecha', 
                {
                  initialValue: moment().startOf('year'),
                }
              )(
                  //TODO: ESTO DEBERIA CAMBIAR POR EL YEAR PICKER CUANDO SE ACTUALICE ANTD A V4
                  <DatePicker
                    picker="year"
                    style={{ width: 415, marginLeft: 10 }}
                    onChange={dateString => this.cambiarFecha(dateString)}
                />
                )}
              </FormItem>
            </Col>
          </Row>

          <Row>
            <Col span={16} offset={4}>
              <FormItem
                {...formItemLayout}
                label={
                  <span>
                    Organismo
                    <Tooltip title="Seleccione el organismo del reporte">
                      <Icons.QuestionCircleOutlined />
                    </Tooltip>
                  </span>
                }
              >
                {getFieldDecorator('idOrganismo', {
                  initialValue: usuario.organismo._id,
                })(
                  <Select
                    style={{ width: 415, marginLeft: 10 }}
                    id="organismos"
                    placeholder="Seleccione el organismo"
                    disabled={
                      usuario.rol != 'ESTADISTICA' &&
                      usuario.rol != 'SUPERVISOR' &&
                      usuario.rol != 'DGJP_DIRECTOR'
                    }
                    onSelect={valor => this.cambiarOrganismo(valor)}
                  >
                    {this.props.data.getOrganismos &&
                      this.props.data.getOrganismos.reduce(function(
                        filtered,
                        organismo
                      ) {
                        if (organismo.nombre.includes('JUZGADO DE PAZ')) {
                          let opcion = (
                            <Select.Option key={organismo._id}>
                              {organismo.nombre}
                            </Select.Option>
                          );
                          filtered.push(opcion);
                        }
                        return filtered;
                      },
                      [])}
                  </Select>
                )}
              </FormItem>
            </Col>
          </Row>

          <FormItem {...tailFormItemLayout}>
            <Button htmlType="submit" style={{ marginLeft: '40%' }}>
              Generar Planilla de Estadistica
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create()(FormRangoFechas);
